var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_17072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6215 -0.00195312C5.62648 -0.00195312 0.766479 4.85805 0.766479 10.853C0.766479 15.9436 4.27134 20.2153 8.99935 21.3885V14.1703H6.76104V10.853H8.99935V9.42366C8.99935 5.72905 10.6714 4.01657 14.2988 4.01657C14.9865 4.01657 16.1732 4.1516 16.6586 4.28621V7.29304C16.4025 7.26612 15.9574 7.25266 15.4047 7.25266C13.6249 7.25266 12.9371 7.92697 12.9371 9.67984V10.853H16.4828L15.8736 14.1703H12.9371V21.6286C18.3121 20.9795 22.4769 16.403 22.4769 10.853C22.4765 4.85805 17.6165 -0.00195312 11.6215 -0.00195312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_17072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.71,
    height: 21.71,
    fill: "white",
    transform: "translate(0.766479 -0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6262718453bd2f2457dff2b3c0b13f79.svg";
export { ForwardRef as ReactComponent };